import mainRequest from './mainRequest.json';
import mainSection from './mainSection.json';

export const budget = {
  mainRequest,
  mainSection,
};
